import React, { type FC } from 'react';
import { Direction } from '@bynder-studio/structured-text';
import { Button } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { IconWritingDirectionLTR, IconWritingDirectionRTL } from '@bynder/icons';
import { useTextElementDirection } from 'packages/pages/design/hooks/useTextElementDirection';
import MaybeTooltip from 'packages/common/MaybeTooltip';
import { RightBox } from 'packages/pages/design/components/TextElement/Component.styled';

export type TextDirectionProps = {
    elementId: number;
    disabled: boolean;
};

export const TextDirection: FC<TextDirectionProps> = ({ elementId, disabled }) => {
    const { translate } = useTranslate();
    const { handleDirectionChange, direction } = useTextElementDirection(elementId);

    return (
        <RightBox>
            <MaybeTooltip
                hasTooltip={!disabled}
                position="top-right"
                content={translate('editor.sidebar.shots.text.direction.switch')}
            >
                <Button
                    isSmall
                    onClick={handleDirectionChange}
                    variant="clean"
                    isDisabled={disabled}
                    icon={direction === Direction.RTL ? <IconWritingDirectionRTL /> : <IconWritingDirectionLTR />}
                    aria-label={translate('editor.sidebar.shots.text.direction.label')}
                />
            </MaybeTooltip>
        </RightBox>
    );
};
